export const name = 'gzSplash';

/**
 * @param {string=} type. Type name for splash template to load

 * @description
 * `<gz-splash>` is a widget that displays a product specific splash. (ex. an OEE equation)
 *
 * @usage
 * ```html
 * <gz-splash
 *   type='oee'
 * >
 *
 * ```
 */
export default function gzSplash(
  // Directive angular dependencies
  $compile
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    scope: {
      type: '=',
    },
    // template: require('./splash.jade'),
    link: splashLink,
    controller: splashController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function splashLink(scope, element, attrs) {
    let splashElement = $compile(`<${scope.vm.type} layout-fill layout='column' layout-align='start start'></${scope.vm.type}>`)(scope);
    element.append(splashElement[0]);
  }

  /** @ngInject */
  function splashController(
    // Controller angular dependencies
  ) {
    // Constants

    // Variables

    // View Model
    let vm = this;
    //   VM properties
    //   VM methods

    vm.$onInit = onInit;
    return;

    ///////////////
    // Init
    function onInit() {
    }

    ///////////////
    // VM methods

    ///////////////
    // Helpers
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/carousel/splash/splash.directive.js